import { render, staticRenderFns } from "./vinCard.vue?vue&type=template&id=6b1c3d73"
import script from "./vinCard.vue?vue&type=script&lang=js"
export * from "./vinCard.vue?vue&type=script&lang=js"
import style0 from "./vinCard.vue?vue&type=style&index=0&id=6b1c3d73&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports